import { SUPPORTED_LANGUAGES, type SupportedLanguage } from '@/lib/i18n/config';
import type { TFunction } from 'i18next';

export const LANGUAGE_I18N_KEYS: Record<SupportedLanguage, string> = {
  ja: '日本語',
  en: '英語',
};

export const getLanguageI18nKey = (language: SupportedLanguage) =>
  LANGUAGE_I18N_KEYS[language];

export type LanguageOption = {
  value: SupportedLanguage;
  label: string;
};

export const getLanguageOptions = (t: TFunction): LanguageOption[] =>
  SUPPORTED_LANGUAGES.map((language) => ({
    value: language,
    label: t(getLanguageI18nKey(language)),
  }));

export const findLanguageOption = (
  language: SupportedLanguage,
  options: LanguageOption[]
) => options.find((option) => option.value === language);
